<template>
  <div id="_2026_1">
    <div id="The-fifth-Asian-young-geographers-workshop" class="cos-modal">
      <h3><strong>The Fifth Asian Young Geographers Workshop Successfully Held at South China Normal University</strong></h3>
      <small class="home-date">June 8, 2026<br></small>
      <hr>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The Fifth Asian Young Geographers Workshop was held at the Shipai
        Campus of South China Normal University from June 5 to 7, 2026. The workshop was jointly
        organized by the Young Geographers Working Group of the Asian Geographical Association
        (AGA-YGWG), the Working Committee for Young Geographers of the Geographical Society of
        China (GSC-WCYG), the IGU Young and Early Career Geographers Commission (IGU-YECG), and
        South China Normal University. It was hosted by the School of Geography and the Center
        for Asian Geographical Studies at South China Normal University, with support from the
        Belt and Road Initiative Research Branch of the Geographical Society of China and other
        organizations. Under the theme “Innovating Asia, Reshaping the World,” the workshop
        attracted more than 500 experts, scholars, and young geographers from over 20 countries
        and regions. It featured 22 parallel forums and 178 academic presentations.
      </p>

      <figure class="featured-photo">
        <img
          src="../../../assets/static/img/Events/2026_1/01-workshop-overview.png"
          alt="The Fifth Asian Young Geographers Workshop at South China Normal University"
        >
        <figcaption>The Fifth Asian Young Geographers Workshop</figcaption>
      </figure>

      <h4>Opening Ceremony</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The opening ceremony was held on the morning of June 6 in the
        International Conference Hall on the first floor of the South China Normal University
        Library. Prof. Yungang Liu, Dean of the School of Geography, chaired the ceremony.
        Hengyin Wang, Secretary of the CPC South China Normal University Committee; Prof. Suresh
        Chand Rai, Vice President of the Asian Geographical Association; Prof. Nathalie
        Lemarchand, President of the International Geographical Union; Prof. Fahu Chen, Secretary
        of the CPC Committee of the Geographical Society of China and an academician of the
        Chinese Academy of Sciences; and Prof. Min Chen, Chair of AGA-YGWG, delivered welcome
        addresses.
      </p>

      <div class="photo-grid">
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/02-yungang-liu-opening.png"
            alt="Professor Yungang Liu chairing the opening ceremony"
          >
          <figcaption>Prof. Yungang Liu chairs the opening ceremony</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/03-hengyin-wang.png"
            alt="Hengyin Wang addressing the workshop"
          >
          <figcaption>Hengyin Wang addresses the workshop</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/04-suresh-chand-rai.png"
            alt="Professor Suresh Chand Rai addressing the workshop"
          >
          <figcaption>Prof. Suresh Chand Rai addresses the workshop</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/05-nathalie-lemarchand.png"
            alt="Professor Nathalie Lemarchand addressing the workshop"
          >
          <figcaption>Prof. Nathalie Lemarchand addresses the workshop</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/06-fahu-chen-opening.png"
            alt="Professor Fahu Chen addressing the workshop"
          >
          <figcaption>Prof. Fahu Chen addresses the workshop</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/07-min-chen-opening.png"
            alt="Professor Min Chen addressing the workshop"
          >
          <figcaption>Prof. Min Chen addresses the workshop</figcaption>
        </figure>
      </div>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;On behalf of South China Normal University, Hengyin Wang warmly
        welcomed the international guests, experts, scholars, and young researchers and thanked
        the faculty members, students, and staff who prepared the workshop. He introduced the
        development of the university and its School of Geography. Founded in 1933, South China
        Normal University has become a national Double First-Class university with distinctive
        strengths in teacher education and a comprehensive range of disciplines. The School of
        Geography also traces its origins to 1933. Guided by the geographical spirit of uniting
        knowledge with action and applying scholarship to practical needs, it has established a
        complete undergraduate, master’s, doctoral, and postdoctoral training system, while its
        Earth Sciences discipline ranks among the top one percent worldwide in the Essential
        Science Indicators. He expressed the hope that the workshop would become a forum for
        intellectual exchange, a bridge for lasting friendship, and an opportunity to shape the
        future.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Prof. Suresh Chand Rai noted that environmental change,
        socioeconomic transformation, and technological innovation are reshaping spatial
        relationships and governance between Asia and the wider world. Geography, he argued,
        should contribute to a more resilient, equitable, and sustainable world through knowledge
        production and interdisciplinary cooperation. Prof. Nathalie Lemarchand emphasized the
        International Geographical Union’s long-standing commitment to global exchange and
        collaboration and described young geographers as an essential force for theoretical
        renewal, interdisciplinary integration, and international cooperation.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Prof. Fahu Chen observed that, since its launch in 2021, the Asian
        Young Geographers Workshop has grown into an important platform for academic exchange,
        intellectual dialogue, and collaboration among young geographers. He encouraged
        participants to broaden their international perspectives and contribute geographical
        knowledge to sustainable development in Asia and around the world. Prof. Min Chen
        reviewed the workshop’s development and encouraged young scholars to share their
        research, expand their collaborative networks, and jointly advance innovation in Asian
        geography.
      </p>

      <h4>Keynote Presentations on June 6</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Following the opening ceremony, the workshop moved into its
        keynote sessions. Prof. Fahu Chen delivered “The Emergence of Homo sapiens in Asia and
        High-Altitude Adaptation,” drawing on paleoanthropological fossils, archaeogenetics, and
        environmental evolution to explain the dispersal of early modern humans in Asia and their
        adaptation to the Qinghai–Tibet Plateau. Prof. Nathalie Lemarchand of Paris 8 University
        delivered “Reinventing Geography, Reshaping the World,” reflecting on theoretical renewal
        in geography amid global transformation through the lenses of historical geography and
        the construction of regional concepts.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Prof. Xin Li of the Institute of Tibetan Plateau Research,
        Chinese Academy of Sciences, presented “Toward Complex Geographical Systems: Adaptive
        Governance and Sustainable Development Based on Multi-Agent Reinforcement Learning,”
        demonstrating the potential of artificial intelligence and geographic information
        science for governing complex human–environment systems. Prof. Chris Gibson of the
        University of Sydney delivered “The Role of Seaports in Changing Energy Geographies:
        Decarbonization Infrastructure, Labour, and Capital,” analyzing the spatial restructuring
        of ports, capital, labour, and infrastructure amid the global energy transition.
      </p>

      <div class="photo-grid">
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/08-fahu-chen-keynote.png"
            alt="Professor Fahu Chen delivering a keynote presentation"
          >
          <figcaption>Prof. Fahu Chen delivers a keynote presentation</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/09-nathalie-lemarchand-keynote.png"
            alt="Professor Nathalie Lemarchand delivering a keynote presentation"
          >
          <figcaption>Prof. Nathalie Lemarchand delivers a keynote presentation</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/10-xin-li-keynote.png"
            alt="Professor Xin Li delivering a keynote presentation"
          >
          <figcaption>Prof. Xin Li delivers a keynote presentation</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/11-chris-gibson-keynote.png"
            alt="Professor Chris Gibson delivering a keynote presentation"
          >
          <figcaption>Prof. Chris Gibson delivers a keynote presentation</figcaption>
        </figure>
      </div>

      <h4>Parallel Forums on June 6</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;On the afternoon of June 6, 17 parallel and thematic forums were
        held in the North Building of South China Normal University’s First Classroom Building.
        Topics included Belt and Road urban heritage strategies and renewal practices; Asian
        hydrological challenges; urban resilience and transport governance; terrestrial
        ecosystems and global climate change; migration and rural revitalization; housing and
        socio-spatial transformation; territorial spatial planning and spatiotemporal big data;
        population change and migration trends; spatial intelligence and resilient cities;
        spatially integrated humanities and social sciences; ecosystem services; climate change
        and environmental impacts across the Pan-Third Pole; intelligent sensing for ecological
        security in southern coastal zones; geography and education for sustainable development;
        urban renewal and governance innovation in the Global South; a journal editors’ forum;
        and a marine political geography forum. Participants held in-depth discussions on
        frontier issues including urban renewal, ecological conservation, water security,
        population mobility, spatial intelligence, geographical education, and regional
        governance.
      </p>

      <figure class="featured-photo">
        <img
          loading="lazy"
          src="../../../assets/static/img/Events/2026_1/12-parallel-forums.png"
          alt="Parallel forums at the workshop"
        >
        <figcaption>Parallel forums at the workshop</figcaption>
      </figure>

      <h4>Keynote Presentations on June 7</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;A further series of keynote presentations was held on the morning
        of June 7. Prof. Yungang Liu of South China Normal University delivered “The Development
        and Prospects of Political Geography in China,” systematically reviewing the field’s
        evolution, research orientations, and future directions. Prof. Michael Meadows of
        Nanjing University presented “Innovating Asia, Reshaping Environmental Futures: Insights
        from China’s Ecological Restoration Experience.” Drawing on vegetation recovery on the
        Qinghai–Tibet Plateau, soil and water conservation on the Loess Plateau, and the Three-
        North Shelterbelt Program, he discussed how China’s ecological restoration experience
        could strengthen regional ecological resilience.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Prof. James Sidaway of the National University of Singapore
        delivered “The Future of Financial Geography in the Dialectics of Geoeconomics and
        Geopolitics,” examining the dollar system, geopolitical change, and the evolving global
        financial order through the lens of financial geography. Prof. SooJin Park of Seoul
        National University, President of the Korean Geographical Society, discussed key issues
        in Korea’s spatial sustainability and proposed a “compact networking” spatial strategy
        to address population decline and regional imbalance.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Prof. Prem Sagar Chapagain of Tribhuvan University, President of
        the Nepal Geographical Society, reviewed the development of geographical research and
        education in Nepal and introduced the society’s role in national planning and
        disciplinary development. Prof. Pannee Cheewinsiriwat of Chulalongkorn University,
        Thailand, introduced plans for the Seventh Asian Conference on Geography.
      </p>

      <div class="photo-grid">
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/13-yungang-liu-keynote.png"
            alt="Professor Yungang Liu delivering a keynote presentation"
          >
          <figcaption>Prof. Yungang Liu delivers a keynote presentation</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/14-michael-meadows-keynote.png"
            alt="Professor Michael Meadows delivering a keynote presentation"
          >
          <figcaption>Prof. Michael Meadows delivers a keynote presentation</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/15-james-sidaway-keynote.png"
            alt="Professor James Sidaway delivering a keynote presentation"
          >
          <figcaption>Prof. James Sidaway delivers a keynote presentation</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/16-soojin-park-keynote.png"
            alt="Professor SooJin Park delivering a keynote presentation"
          >
          <figcaption>Prof. SooJin Park delivers a keynote presentation</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/17-prem-sagar-chapagain-keynote.png"
            alt="Professor Prem Sagar Chapagain delivering a keynote presentation"
          >
          <figcaption>Prof. Prem Sagar Chapagain delivers a keynote presentation</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/18-pannee-cheewinsiriwat.png"
            alt="Professor Pannee Cheewinsiriwat introducing the Seventh Asian Conference on Geography"
          >
          <figcaption>
            Prof. Pannee Cheewinsiriwat introduces the Seventh Asian Conference on Geography
          </figcaption>
        </figure>
      </div>

      <h4>Parallel Forums on June 7</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Multiple parallel forums continued on the afternoon of June 7.
        “Toward a Sustainable China–ASEAN Blue Economy” focused on marine cooperation and
        resilience in the blue economy. “Energy Geography and Sustainable Development” addressed
        renewable-energy deployment, photovoltaic planning, electric-vehicle charging-station
        locations, and the potential of distributed solar energy. “Dialogues in Asian Human
        Geography” examined technology transfer, spatial behavior, tourism livelihoods,
        identity, and rural revitalization.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The “Spatially Integrated Humanities and Social Sciences” forum
        presented interdisciplinary research on climate-risk mapping, urban security, health
        exposure, and spatial forecasting models. “Smart and Sustainable Urban Development”
        explored frontier topics including vision-language models, urban heat islands, heat-wave
        risk, geographic flow modeling, and public-health prediction. The forum on “Investment
        and Special Economic Zones along the Belt and Road” discussed overseas industrial parks,
        infrastructure-led urbanization, cross-border cooperation, resource governance, and the
        restructuring of global production networks.
      </p>

      <figure class="featured-photo">
        <img
          loading="lazy"
          src="../../../assets/static/img/Events/2026_1/19-parallel-forum.png"
          alt="A parallel forum at the workshop"
        >
        <figcaption>A parallel forum at the workshop</figcaption>
      </figure>

      <h4>Closing Ceremony and Excellent Paper Awards</h4>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The closing ceremony and Excellent Paper Awards presentation were
        held on the afternoon of June 7 in Room 605 of the North Building of the First Classroom
        Building. Prof. Li He of Xi’an Jiaotong University, Secretary of AGA-YGWG, chaired the
        ceremony. In his summary, Prof. Min Chen, Chair of AGA-YGWG and Dean of the School of
        Geography at Nanjing Normal University, reviewed the workshop’s achievements: 22 parallel
        forums, 178 academic presentations, and more than 500 participants from over 20 countries
        and regions. He thanked the School of Geography and the Center for Asian Geographical
        Studies at South China Normal University, the conference team, and nearly 100 student
        volunteers for their work. He also invited young geographers around the world to join
        AGA-YGWG.
      </p>

      <div class="photo-grid">
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/20-li-he-closing.png"
            alt="Professor Li He chairing the closing ceremony"
          >
          <figcaption>Prof. Li He chairs the closing ceremony</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/21-min-chen-closing.png"
            alt="Professor Min Chen delivering the workshop summary"
          >
          <figcaption>Prof. Min Chen delivers the workshop summary</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/22-closing-ceremony.png"
            alt="Closing ceremony of the workshop"
          >
          <figcaption>Closing ceremony of the workshop</figcaption>
        </figure>
      </div>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;More than 30 papers were submitted for the Excellent Paper Awards.
        Following a rigorous review, nine papers were selected. Prof. Nathalie Lemarchand,
        President of the International Geographical Union, and Prof. Suresh Chand Rai, Vice
        President of the Asian Geographical Association, presented certificates to the young
        award recipients. Prof. Yungang Liu, Chair of the workshop and Dean of the School of
        Geography at South China Normal University, then delivered closing remarks, thanking all
        participants, organizing committee members, volunteers, and the organizations that
        sponsored, hosted, and supported the workshop. Prof. Michael Meadows, former President of
        the International Geographical Union, also addressed the closing ceremony.
      </p>

      <div class="photo-grid">
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/23-yungang-liu-closing.png"
            alt="Professor Yungang Liu delivering closing remarks"
          >
          <figcaption>Prof. Yungang Liu delivers closing remarks</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/24-michael-meadows-closing.png"
            alt="Professor Michael Meadows addressing the closing ceremony"
          >
          <figcaption>Prof. Michael Meadows addresses the closing ceremony</figcaption>
        </figure>
        <figure>
          <img
            loading="lazy"
            src="../../../assets/static/img/Events/2026_1/25-awards.png"
            alt="Excellent Paper Awards presentation"
          >
          <figcaption>Excellent Paper Awards presentation</figcaption>
        </figure>
      </div>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The workshop was both a high-level international academic event
        and a concentrated demonstration of the knowledge, energy, and international outlook of
        Asia’s young geographers. Its in-depth dialogue on global change, regional cooperation,
        urban governance, ecological restoration, spatial intelligence, and sustainable
        development provided young scholars with an important platform for sharing knowledge,
        exchanging ideas, and developing collaborations. The workshop further enhanced the
        international influence of geography at South China Normal University and deepened
        cooperation between its School of Geography, its Center for Asian Geographical Studies,
        and geographical communities across Asia and around the world.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2026_1'
}
</script>

<style lang="less" scoped>
#_2026_1 {
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 2.2rem auto 0;
  position: relative;
  word-spacing: 0.3rem;
  min-height: 4000px;
  text-align: justify;
}

h3,
h4 {
  color: #117450;
  font-weight: 1000;
}

h3 {
  font-size: 1.3rem;
}

h4 {
  margin: 2rem 0 1rem;
  font-size: 1.2rem;
}

.home-date {
  font-weight: bold;
  color: grey;
}

figure {
  margin: 0;
}

.featured-photo {
  width: 100%;
  margin: 2% 0;
  text-align: center;
}

.featured-photo img {
  max-width: 80%;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  margin: 2% 0;
}

.photo-grid figure {
  text-align: center;
}

figure img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
}

figcaption {
  margin-top: 0.4rem;
  color: grey;
  font-size: 0.9rem;
  line-height: 1.4rem;
  text-align: center;
}

@media (max-width: 768px) {
  #_2026_1 {
    width: 88%;
    min-height: 0;
  }

  .featured-photo img {
    max-width: 100%;
  }

  .photo-grid {
    grid-template-columns: 1fr;
  }
}
</style>
